// Function to get matched department IDs
export const getMatchedDepartmentIds = (
  userDepartments,
  conversationDepartments
) => {
  return !Array.isArray(userDepartments) ||
    !Array.isArray(conversationDepartments)
    ? []
    : userDepartments
        ?.filter((userDept) =>
          conversationDepartments?.some(
            (convoDept) => convoDept.id === userDept.id
          )
        )
        ?.map((userDept) => userDept.id); // Extracting only the ids
};
